// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2UUJ7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__6EGZN"};